(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-footer-main';
  var TOGGLE_SELECTOR = '.oddit-footer-main__column-toggle';
  var DESKTOP_BREAKPOINT = '(min-width: 750px)';

  function initSection(section) {
    if (!section || section.dataset.odditFooterInit === 'true') return;
    section.dataset.odditFooterInit = 'true';

    var toggles = section.querySelectorAll(TOGGLE_SELECTOR);
    var mql = window.matchMedia(DESKTOP_BREAKPOINT);

    function setExpanded(toggle, expanded) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function syncForViewport() {
      var isDesktop = mql.matches;
      toggles.forEach(function (toggle) {
        if (isDesktop) {
          // On desktop, the lists are always visible via CSS, but reflect that in ARIA
          setExpanded(toggle, true);
        } else {
          // On mobile, collapse all by default
          setExpanded(toggle, false);
        }
      });
    }

    function handleToggleClick(event) {
      // Ignore on desktop where toggle is non-interactive
      if (mql.matches) return;
      var toggle = event.currentTarget;
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      setExpanded(toggle, !expanded);
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', handleToggleClick);
    });

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', syncForViewport);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(syncForViewport);
    }

    syncForViewport();
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();